import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, take, takeUntil } from 'rxjs';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';

import { MatTableDataSource } from '@angular/material/table';
import { SaleHorseNoteModel } from 'src/app/models/sales/sale-horse-note.model';
import { HttpErrorHandlerService } from 'src/app/services/http-error-handler.service';
import { ViewerService } from 'src/app/services/viewer.service';
import { StudyFileNotificationModalComponent } from '../study-file-notification-modal/study-file-notification-modal.component';
import { XrayModalComponent } from '../xray-modal/xray-modal.component';
import { EventsEmitter } from '../../../../shared/event-emitter/EventEmitter';
import { NotificationsService } from '../../../../services/notifications.service';
import { AuthService } from 'src/app/services/auth.service';
import { StudyStatus } from '../../../../shared-new/enums/study-status.enum';
import { Status } from '../../../../models/status/status.model';
import { DownloadUtilsService } from 'src/app/services/download-utils-service';

@Component({
  selector: 'app-review-study',
  templateUrl: './review-study.component.html',
  styleUrls: ['./review-study.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewStudyComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  displayedColumns: string[] = [
    'submittedBy',
    'date',
    'open',
    'status',
    'stamped',
    'comment',
    'action',
  ];

  mp4StudyFiles: StudyFile[] = [];
  pdfStudyFiles: StudyFile[] = [];
  xrayStudyFiles: StudyFile[] = [];


  statuses: any[];

  mediaCategories: MediaCategory[] = [];

  deniedStudyFileIds: number[] = [];

  studyFilesByTypeAndStatusMap$ =
    this.studyFacade.studyFilesByTypeAndStatusMap$;
  activeSaleHorseStudy$ = this.studyFacade.activeSaleHorseStudy$;
  scopeDatasource: any[] = [];
  reportDatasource: any[] = [];
  xrayDatasource: any[] = [];

  xrayImagesMap: {
    studyFileIds: number[];
    studyFile: StudyFile;
  }[] = [];
  activityLogId: number = 0;
  isActivtyEnded: boolean = true;
  @Input() isUserSaleEditor: boolean = false;
  @Input() isVetEditor: boolean = false;
  @Input() isViewerOnly: boolean = false;
  public lotOrHipText: string;
  studyStatusError$ = this.studyFacade.studyStatusError$;
  studyStatusSuccess$ = this.studyFacade.studyStatusSuccess$;

  isLoader: boolean = false;
  loggedInMemberId: number = null;
  selectAll = false;
  selectedItems: any[] = [];
  StudyStatus = StudyStatus;
  public selectedText: string = "In Review";
  public dataSource: MatTableDataSource<SaleHorseNoteModel>;
  isSalesCompany: boolean = false;
  public displayedColumns$ = new BehaviorSubject([
    'submittedBy',
    'date',
    'notes',
  ]);
  constructor(
    private studyFacade: StudiesFacade,
    private modalService: NgbModal,
    private viewerService: ViewerService,
    private readonly eventEmitter: EventsEmitter,
    private readonly notificationService: NotificationsService,
    private authService: AuthService,
    private changeDetectorRefs: ChangeDetectorRef,
    private downloadUtilsService: DownloadUtilsService
  ) {
    super();
    this.isSalesCompany = this.authService.IsSalesCompany();
    this.authService.getUserData().pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      const user = JSON.parse(data);
      this.loggedInMemberId = user.memberId;
    });
  }



  /** Toggle select all across all tables */
  toggleAllSelection(checked: boolean) {
    this.selectAll = checked;
    if (!checked) {
      this.selectAll = false;
      this.selectedItems = [];
      this.changeDetectorRefs.detectChanges();
    }
  }

  getFilteredStatuses() {
    return this.statuses?.filter(x => x.id > StudyStatus.Submitted)
  }

  openApproveOrDenyPopup(statusId: number) {
    if (statusId == StudyStatus.Approved) {
      this.selectedText = "Approved";
    } else {
      this.selectedText = "Denied";
    }
    let selectedStudyFileIds = this.selectedItems
      .filter(x => x.type === 'X-RAY IMAGES')
      .flatMap(item => item.selectedHorses.map((horse: any) => horse.studyFileIds))
      .reduce((acc, curr) => acc.concat(curr), []);

    const selectedStudyFileIdsReports = this.selectedItems
      .filter(x => x.type !== 'X-RAY IMAGES')
      .flatMap(item => item.selectedHorses.map((horse: any) => horse.studyFileId)); // Use flatMap to avoid nesting

    // Merge both arrays
    const mergedStudyFileIds = [...selectedStudyFileIds, ...selectedStudyFileIdsReports];
    if (mergedStudyFileIds.length > 0) {
      this.deniedStudyFileIds = mergedStudyFileIds;
      this.openDenyModal(null, statusId, mergedStudyFileIds)
    }

  }

  /** Update selection from child components */
  updateSelection(selection: any) {
    // Find the index of the existing selection with the same type
    const index = this.selectedItems.findIndex(item => item.type === selection.type);

    if (index !== -1) {
      // Replace existing item with the new selection
      this.selectedItems[index] = selection;
    } else {
      // Push new selection if it doesn't exist
      this.selectedItems.push(selection);
    }

  }

  isIndeterminate(): boolean {
    if (this.isAllSelected()) {
      return false;
    }
    if (this.getTotalSelectedItems() > 0) {
      return true;
    }
    return false;
    //return this.selectedItems.some(item => item.isAllSelected) && !this.isAllSelected();
  }
  /** Check if all tables have all items selected */
  isAllSelected(): boolean {
    if (this.getTotalSelectedItems() == 0) {
      return false;
    }
    // Ensure all selected items have isAllSelected set to true
    return this.selectedItems.length > 0 && this.selectedItems.every(item => item.isAllSelected);
  }
  getTotalSelectedItems(): number {
    return this.selectedItems.reduce((total, item) => total + item.selectedHorses.length, 0);
  }


  ngOnInit(): void {
    this.studyFacade.mediaCategories$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((mediaCategories) => {
        this.mediaCategories = mediaCategories;
      });
    this.studyFacade.studyStatusUpdated$.pipe((takeUntil(this.unsubscribe$))).subscribe((response) => {
      if (response) {
        this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
          if (study.saleId > 0 && study.horseId) {
            this.studyFacade.getSaleHorseStudies(study.saleId, study.horseId);
            this.toggleAllSelection(false);
          }
        });
        this.studyFacade.clearStudyStatusState();
      }
    })
    this.studyFacade.statuses$.pipe((takeUntil(this.unsubscribe$))).subscribe((response) => {
      let status = [...response];
      if (this.authService.IsSalesCompany()) {
        const nothingSubmitted = StudyStatus.Nothing_Submitted;
        status = status.filter(x => x.id > nothingSubmitted);
      }
      this.statuses = [...status];
    })
    this.fetchFiles();
    this.authService
      .getMemberLotOrHipText()
      .pipe(take(1))
      .subscribe((text) => {
        this.lotOrHipText = text;
      });
  }

  fetchFiles() {
    this.studyFilesByTypeAndStatusMap$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((map) => {
        this.dataSource = new MatTableDataSource<SaleHorseNoteModel>(
          map.saleHorseNotes
        );

        const scopeVideoDatasource = this.filterByMember(map.mp4StudyFiles).map((studyFile) =>
          this.createDatasourceModel(studyFile, [studyFile.studyFileId])
        );
        this.scopeDatasource = [...scopeVideoDatasource];

        //const reportDatasource = map.pdfStudyFiles.map((studyFile) =>
        //  this.createDatasourceModel(studyFile, [studyFile.studyFileId])
        //);

        //this.reportDatasource = [...reportDatasource];
        const xrayStudyFileItems = map.xrayStudyFileItems.filter(x => this.authService.IsSalesCompany() || x.studyFile.memberId === this.loggedInMemberId);

        const xrayDatasource = xrayStudyFileItems.map((model) =>
          this.createDatasourceModel(model.studyFile, model.studyFileIds)
        );
        this.xrayImagesMap = xrayStudyFileItems;

        this.xrayDatasource = [...xrayDatasource];

        this.mp4StudyFiles = this.filterByMember(map.mp4StudyFiles);

        this.pdfStudyFiles = this.filterByMember(map.pdfStudyFiles);

        this.xrayStudyFiles = this.filterByMember(map.xrayStudyFiles);

        this.changeDetectorRefs.markForCheck();
      });
  }

  updateStatus(data: { studyFile: StudyFile, studyFileIds: number[]; statusId: number }): void {
    if (data.statusId === StudyStatus.Denied || data.statusId === StudyStatus.Approved) {
      this.deniedStudyFileIds = data.studyFileIds;
      this.openDenyModal(data.studyFile, data.statusId, data.studyFileIds);
    } else {
      this.deniedStudyFileIds = [];
      this.updateStudyFileStatuses(data.studyFileIds, data.statusId);
    }

    this.studyStatusError$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((err) => {
        if (err) {
          this.studyFacade.clearStudyStatus();
          this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
            if (study.saleId > 0 && study.horseId) {
              this.studyFacade.resetData();
              this.studyFacade.getSaleHorseStudies(study.saleId, study.horseId);
            }
          });

          //this.httpErrorHandlerService.ShowErrorMessage(err);
          this.isLoader = false;
        }
      });
    this.studyStatusSuccess$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (response) {
          this.studyFacade.clearStudyStatus();
          this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
            if (study.saleId > 0 && study.horseId) {
              this.studyFacade.resetData();
              this.studyFacade.getSaleHorseStudies(study.saleId, study.horseId);
            }
          });
          this.isLoader = false;
          this.eventEmitter.emitUpdateStudyFileStatus();
        }
      });
  }

  createDatasourceModel(
    studyFile: StudyFile,
    studyFileIds: number[]
  ): any {
    const model = JSON.parse(JSON.stringify(studyFile));
    model.studyFileIds = studyFileIds;
    model.date = studyFile.studyStatusDate;
    model.imageCount = studyFileIds.length;
    model.stamped = studyFile.isStamped;
    model.status = studyFile.studyStatusId;
    model.originalStatus = studyFile.studyStatusId;
    return model;
  }

  filterByMember(studyFiles: StudyFile[]) {
    // In review tab, files can either be seen by sales company or by the uploader of the files.
    if (this.authService.IsSalesCompany()) {
      return studyFiles;
    }
    return studyFiles?.filter(a => this.authService.IsSalesCompany() || a.memberId === this.loggedInMemberId) ?? [];
  }

  openVideoModal(studyFileIds: number[]): void {
    this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
      if (studyFileIds.length) {
        const video = this.mp4StudyFiles.filter(x => studyFileIds.includes(x.studyFileId));
        if (video.length > 0) {
          this.viewerService.playVideo(study, video[0],null,false,null,false);
        }
      }
    });
  }

  openPdf(studyFileIds: number[]): void {
    this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
      if (studyFileIds.length) {
        const file = this.pdfStudyFiles.filter(x => studyFileIds.includes(x.studyFileId));
        if (file.length > 0) {
          this.viewerService.openPdf(study, file[0], null, false, null, false);
        }
      }
    });
  }

  openImageViewer(studyFileIds: number[],isEditable: boolean = false): void {
    const modalRef = this.modalService.open(XrayModalComponent, {
      size: 'xl',
      centered: true,
      keyboard: false,
      backdrop: 'static',
      fullscreen: true,
    });

    const files = this.xrayStudyFiles.filter((sf) =>
      studyFileIds.includes(sf.studyFileId)
    );
    const matchedXrays = files.filter((i) => !i.isAdditional);
    const additionalXrays = files.filter((i) => i.isAdditional);

    modalRef.componentInstance.studyFileIds = matchedXrays.map(x => x.studyFileId);
    modalRef.componentInstance.isEditable = isEditable;
    modalRef.componentInstance.additionalFiles = additionalXrays;
    modalRef.componentInstance.mediaCategories = this.mediaCategories;
  }

  openXrayDownloaderPopup(studyFileIds: number[]): void {
    const files = this.xrayStudyFiles.filter((sf) =>
      studyFileIds.includes(sf.studyFileId)
    );
    this.downloadUtilsService.triggerDownloaderPopup(null, files, [], [], 'submissions');
  }

  openVideoDownloader(studyFileIds: number[]): void {
    const file = this.mp4StudyFiles.filter(x => studyFileIds.includes(x.studyFileId));
    if (file.length > 0) {
      this.downloadUtilsService.triggerFileDownload(file[0].thumbURL, file[0].originalFileName);
    }
  }

  openDocDownloader(studyFile: StudyFile): void {
    this.downloadUtilsService.triggerFileDownload(studyFile.thumbURL, studyFile.originalFileName);
  }

  openDenyModal(studyFile: any, statusId: number, studyFileIds: number[]): void {
    this.activeSaleHorseStudy$.pipe(take(1)).subscribe((study) => {
      this.notificationService.getStudySubmissionRecipients(study.saleId, study.horseId, statusId, studyFileIds).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
        const modalRef = this.modalService.open(StudyFileNotificationModalComponent, {
          size: 'lg',
          centered: true,
          keyboard: false,
          backdrop: 'static',
        });
        const { recipients, ...rest } = response;

        // Only the submitting vet's recipients: "viewed by" vets are never told about an approval or a
        // denial (they get the separate New Data Submitted notification).
        const submittingRecipients = (recipients || []).filter((r: any) => !r.isViewingOnly);

        // Create independent objects
        const notificationData = {
          ...rest,
          recipients: submittingRecipients
        };

        modalRef.componentInstance.data = {
          statusId: statusId,
          notificationData: notificationData,
          lotOrHipText: this.lotOrHipText,
        };

        modalRef.result.then(
          (result) => {
            const reason = result.reason;
            const notificationData = result.notificationData;
            this.updateStudyFileStatuses(this.deniedStudyFileIds, statusId, reason, notificationData);
            this.selectedText = "In Review";
            this.changeDetectorRefs.detectChanges();
          },
          (reason) => {
            if (studyFile) {
              studyFile.status = studyFile.originalStatus;
            } else {
              this.selectedText = "In Review";
            }
            this.changeDetectorRefs.detectChanges();
          }
        );
      });
    })
  }

  updateStudyFileStatuses(
    studyFileIds: number[],
    statusId: number,
    reason?: string,
    notificationData?: any
  ): void {
    this.isLoader = true;
    this.studyFacade.updateStudyFileStatuses(studyFileIds, statusId, reason, notificationData);
  }
}
